/* Range/Menu client barrel export */

import { IRangeClient } from './IRangeClient';
import { RangeClientApi } from './rangeClientApi';
import { RangeClientMocked } from './rangeClientMocked';
import { isDemoModeEnabled } from '../../../../utils/featureAccess';

export * from './rangeTypes';
export * from './IRangeClient';

// Demo fixtures are opt-in. QA and production use gateway/API data by default.
export const rangeClient: IRangeClient = isDemoModeEnabled()
  ? new RangeClientMocked()
  : new RangeClientApi();

export { RangeClientApi, RangeClientMocked };
